(function (root, factory) {
  'use strict';

  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.LacNamFitMath = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var constants = Object.freeze({
    minCm: 22,
    maxCm: 31,
    stepCm: 0.1,
    defaultCm: 26.5,
    rulerOrigin: 72,
    rulerUnit: 17.5
  });

  function calculate(cm, selectedUnit) {
    var lengthCm = Number(cm);
    if (!Number.isFinite(lengthCm)) {
      throw new TypeError('Foot length must be a finite number.');
    }

    var unit = selectedUnit === 'in' ? 'in' : 'cm';
    var inches = lengthCm / 2.54;
    var usMen = Math.min(14, Math.max(4, Math.round(lengthCm - 18)));
    var eu = Math.round(lengthCm * 1.5 + 2);
    var footScaleX = lengthCm * constants.rulerUnit / 31;
    var footScaleY = footScaleX * 0.86;

    return {
      lengthCm: lengthCm,
      inches: inches,
      unit: unit,
      valueText: unit === 'cm' ? lengthCm.toFixed(1) : inches.toFixed(2),
      markerText: unit === 'cm' ? lengthCm.toFixed(1) + ' cm' : inches.toFixed(1) + ' in',
      usMen: usMen,
      usWomen: usMen + 2,
      eu: eu,
      vn: eu,
      uk: usMen - 1,
      progress: (lengthCm - constants.minCm) / 9 * 100,
      markerX: constants.rulerOrigin + lengthCm * constants.rulerUnit,
      lettersX: constants.rulerOrigin + lengthCm * constants.rulerUnit * 0.7,
      footScaleX: footScaleX,
      footScaleY: footScaleY,
      footTransform: 'translate(72px, 200px) scale(' + footScaleX + ', ' + footScaleY + ') translate(16px, 0px) rotate(90deg)'
    };
  }

  return Object.freeze({ version: '1.0.0', constants: constants, calculate: calculate });
});
